<!--
 * @Author: 月魂
 * @Date: 2021-11-16 16:16:03
 * @LastEditTime: 2021-12-10 17:34:46
 * @LastEditors: 月魂
 * @Description: 美术展详情
 * @FilePath: \seven-silk\src\views\ExhibitionDetail.vue
-->
<template>
  <div class="detail">
    <img src="../assets/back.png" alt="" class="back" @click="() => this.$router.go(-1)">
    <div class="header">
      <img :src="`http://image.wearetogether.com.cn/seven-exhibition-poster-${getExhibition.id}.png`" alt="" width="100%" class="banner">
      <div class="sum" v-if="getExhibition.sum">
        <img class="sum-img" src="../assets/playSum.png" alt="">
        <div class="sum-text">{{ this.sum }} {{ this.$t('params.times') }}</div>
      </div>
    </div>
    <div class="cont">
      <div class="title">{{ getExhibition.title }}</div>
      <div class="intro" v-for="(des, index) in getExhibition.des" :key="index">{{ des }}</div>
      <div class="online" v-show="getExhibition.url">
        <img v-if="getExhibition.qrcode" :src="`http://image.wearetogether.com.cn/seven-exhibition-code-${getExhibition.id}.png`" alt="" width="100%" style="display: block">
        <div class="link" @click="jump(getExhibition.url)">{{ this.$t('params.watchOnline') }}</div>
      </div>
      <div class="card">
        <div class="item" v-if="getExhibition.host">
          <div class="item-left">{{ this.$t('params.host') }}：</div>
          <div class="item-right">{{ getExhibition.host }}</div>
        </div>
        <div class="item" v-else>
          <div class="item-left">{{ this.$t('params.organize') }}：</div>
          <div class="item-right">{{ getExhibition.organize }}</div>
        </div>
        <div class="item" v-show="getExhibition.undertake">
          <div class="item-left">{{ this.$t('params.undertake') }}：</div>
          <div class="item-right">{{ getExhibition.undertake }}</div>
        </div>
        <div class="item" v-show="getExhibition.coOrganized">
          <div class="item-left">{{ this.$t('params.coOrganized') }}：</div>
          <div class="item-right">{{ getExhibition.coOrganized }}</div>
        </div>
        <div class="item" v-show="getExhibition.support">
          <div class="item-left">{{ this.$t('params.support') }}：</div>
          <div class="item-right">{{ getExhibition.support }}</div>
        </div>
        <div class="item" v-show="getExhibition.thanks">
          <div class="item-left">{{ this.$t('params.thanks') }}：</div>
          <div class="item-right">{{ getExhibition.thanks }}</div>
        </div>
        <div class="item">
          <div class="item-left">{{ this.$t('params.exhibitionTime') }}：</div>
          <div class="item-right">{{ getExhibition.time }}</div>
        </div>
        <div class="item">
          <div class="item-left">{{ this.$t('params.exhibitionAddress') }}：</div>
          <div class="item-right">{{ getExhibition.address }}</div>
        </div>
      </div>
      <!-- 视频精彩剪辑 -->
      <div class="troupe" v-if="getExhibition.clip">
        <div class="title">{{ this.$t('params.clip') }}</div>
        <video :poster="`http://image.wearetogether.com.cn/seven-exhibition-clip-${getExhibition.id}.png`" controls style="display: block; width: 100%">
          <source :src="`http://image.wearetogether.com.cn/seven-exhibition-clip-${getExhibition.id}.mp4`">
        </video>
      </div>
      <div class="troupe" v-show="getExhibition.review">
        <div class="title">{{ this.$t('params.review') }}</div>
        <img v-for="(img, index) in getExhibition.review" :key="index" :src="`http://image.wearetogether.com.cn/seven-exhibition-poster-${getExhibition.id}-${img}.png`" alt="" class="review" @click="showImg(img)">
      </div>
    </div>
  </div>
</template>

<script>
import vue from 'vue';
import axios from 'axios';
import ImagePreview  from 'vant/lib/image-preview';
import 'vant/lib/image-preview/style';
vue.use(ImagePreview)

export default {
  name: 'ExhibitionDetail',
  data() {
    return {
      sum: 11000,
      imgList: [],
      exhibitionId: 1,
    }
  },
  mounted() {
    this.exhibitionId = this.$route.params.id;
    if (this.exhibitionId == 4) {
      // 大地花开
      axios.get('/api/v1/2').then(res => {
        this.sum = res.data;
      })
      axios.put('/api/v1/2')
    } else if (this.exhibitionId == 5) {
      axios.get('/api/v1/1').then(res => {
        this.sum = res.data;
      })
      axios.put('/api/v1/1')
    }
    // 计算精彩回顾列表
    const pList = this.$t('exhibition.list')[this.exhibitionId - 1]
    if (pList.review && pList.review.length) {
      pList.review.map(item => {
        this.imgList.push(`http://image.wearetogether.com.cn/seven-exhibition-poster-${pList.id}-${item}.png`)
      })
    }
  },
  computed: {
    getExhibition() {
      return this.$t('exhibition.list')[this.exhibitionId - 1]
    }
  },
  methods: {
    jump(url) {
      window.location.href = url;
    },
    showImg(position) {
      if (window.innerWidth <= 1200) {
        ImagePreview({
          images: this.imgList,
          startPosition: position - 1
        });
      }
    }
  }
}
</script>

<style lang="less" scoped>
.detail {
  width: 100%;
  min-height: 100vh;
  // background-image: linear-gradient(to right, #ec6e5a, #b27c9f);
  // color: #fff;
  position: relative;
  .back {
    position: absolute;
    top: 20px;
    left: 10px;
    width: 24PX;
    z-index: 10;
  }
  .header {
    width: 100%;
    max-width: 1200PX;
    margin: auto;
    position: relative;
    .banner {
      display: block;
      width: 100%;
    }
    .sum {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: rgba(0, 0, 0, .5);
      padding: 4px 10px;
      display: flex;
      align-items: center;
      color: #fff;
      .sum-img {
        display: block;
        width: 24px;
        height: 100%;
        margin-right: 3px;
      }
      .sum-text {
        line-height: 1;
        font-size: 12px;
      }
    }
  }
  .cont {
    max-width: 1200PX;
    margin: auto;
    padding: 10px;
    .title {
      font-size: 18px;
      color: #DC7E3F;
      font-weight: bold;
    }
    .intro {
      color: #9a9a9a;
      font-size: 14px;
    }
    .online {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 30%;
        margin-right: 20px;
      }
      .link {
        font-size: 14px;
        text-decoration: underline;
        margin-top: 10px;
      }
    }
    .card {
      background-color: #e9e9e9;
      // background-image: linear-gradient(to right, #f39b03, #984081);
      color: #3a3a3a;
      padding: 10px 10px 10px 20px;
      margin-top: 10px;
      font-size: 14px;
      .item {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        .item-left {
          width: 32%;
        }
        .item-right {
          width: 68%;
          text-align: left;
          // word-break: break-all;
        }
      }
    }
    .troupe {
      .title {
        margin: 10px 0;
      }
      .review {
        display: block;
        width: 100%;
        margin-top: 8px;
      }
    }
  }
}
</style>
